import jsPDF from "jspdf";
import { blackCut } from "../../../constants/images";
import { shiftX } from "./utils";

export const renderTopTerms = (params: {
  doc: jsPDF | any;
  baseX: number;
  baseY: number;
  translate: Function;
}) => {
  const termsY = params.baseY + 108;
  const leftMargin = shiftX(params.baseX + 4);
  const rightMargin = shiftX(params.baseX + 101);

  params.doc.setTextColor("#333333");
  params.doc.setFontSize(5);
  params.doc.setFont("Inter", "medium");
  params.doc.text(params.translate("receipt.terms"), leftMargin, termsY);
  params.doc.text(
    params.translate("receipt.info"),
    rightMargin + 4,
    termsY,
    null,
    null,
    "right"
  );

  // line dashed cutting
  params.doc.setLineDash([1]);
  params.doc.setDrawColor("#A7A8AA");
  params.doc.setLineWidth(0.5);
  params.doc.line(
    shiftX(params.baseX),
    termsY + 2,
    shiftX(params.baseX + 108),
    termsY + 2
  );
  params.doc.addImage(
    blackCut,
    "PNG",
    leftMargin,
    termsY + 0.5,
    2.5,
    2.5,
    "cut",
    "FAST"
  );
  params.doc.setLineDash([], 0);
  params.doc.setDrawColor("#000000");

  return {
    termsY,
    leftMargin,
    rightMargin
  };
};

export const renderBottomTerms = (params: {
  doc: jsPDF | any;
  leftMargin: number;
  rightMargin: number;
  bottomTermsY: number;
  translate: Function;
}) => {
  params.doc.setTextColor("#333333");
  params.doc.setFont("Inter", "medium");
  params.doc.setFontSize(5);
  params.doc.text(
    params.translate("receipt.terms"),
    params.leftMargin,
    params.bottomTermsY
  );
  params.doc.text(
    params.translate("receipt.info"),
    params.rightMargin + 4,
    params.bottomTermsY,
    null,
    null,
    "right"
  );
};
